import type { ButtonWithSpinnerProps } from '@makemydeal/dr-ui-bricks-types';
import { ButtonStyle } from '@makemydeal/dr-ui-bricks-types';
import { PrimaryButtonSpinner, SecondaryButtonSpinner, TertiaryButtonSpinner } from './button.style';
import { Spinner } from '@makemydeal/ui-bricks/dist/cox';

const ButtonWithSpinner: React.FC<ButtonWithSpinnerProps> = ({
    width,
    children,
    className = '',
    buttonStyle = ButtonStyle.PRIMARY,
    buttonSize = 'large',
    disabled = false,
    type = 'button',
    onClick,
    isLoading = false,
    'data-testid': dataTestId
}) => {
    switch (buttonStyle) {
        case ButtonStyle.SECONDARY:
            return (
                <SecondaryButtonSpinner
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                    {isLoading && <Spinner />}
                </SecondaryButtonSpinner>
            );
        case ButtonStyle.TERTIARY:
            return (
                <TertiaryButtonSpinner
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                    {isLoading && <Spinner />}
                </TertiaryButtonSpinner>
            );
        default:
            return (
                <PrimaryButtonSpinner
                    type={type}
                    disabled={disabled}
                    onClick={onClick}
                    className={className}
                    width={width}
                    $buttonSize={buttonSize}
                    data-testid={dataTestId}
                >
                    {children}
                    {isLoading && <Spinner />}
                </PrimaryButtonSpinner>
            );
    }
};
export default ButtonWithSpinner;
